import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { constant } from 'app/app.constants';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { VehiclesService } from 'app/pages/vehicles/vehicles.service';
import { T2CardComponent } from 'app/trip2-theme/components/t2-card/t2-card.component';
import * as moment from 'moment';
import { IMyOptions } from 'mydaterangepicker';
import { ValidateVINService } from './validate-vin.service';

@Component({
  selector: 'app-validate-vin',
  templateUrl: './validate-vin.component.html',
  styleUrls: ['./validate-vin.component.scss'],
})

export class ValidateVINComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('searchModal') private searchModal: T2CardComponent;
  @Output() formValues = new EventEmitter<any>();
  @Input() onDemandDrivers: boolean;
  @Input() isProvider: boolean;
  @Input() vehicleData: any;
  @Input() disabledInput: boolean;
  formValidateVin: FormGroup;
  manual: boolean;
  makeArray: any[] = [];
  modelArray: any[] = [];
  titleModal: string;
  yearsArray: any[] = [];
  dateExpire: any;
  colorArray: any[] = [];
  vinLookupEnabled = false;
  vinLookupLoading = false;
  vinLength = constant.VIN_LENGTH;
  private vinLookupSubscriptions: Subscription[] = [];
  myDatePickerOptions: IMyOptions = {
    showSelectorArrow: false,
    dateFormat: 'mm-dd-yyyy',
  };

  constructor(
    private validateVINService: ValidateVINService,
    private serviceVehicle: VehiclesService,
    private fb: FormBuilder,
    private sweetAlertHelper: SweetAlertHelper,
  ) {
    this.onCreateForm();
    this.onSubscribeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['vehicleData'] && this.vehicleData) {
      let auxDate;
      if (this.vehicleData.registrationexpdate) {
        const date: Date = moment(this.vehicleData.registrationexpdate).toDate();
        auxDate = {
          date: {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate()
          }
        };
        this.dateExpire = auxDate;
      }
      this.formValidateVin.patchValue({
        make: this.vehicleData.make ? this.vehicleData.make : '',
        model: this.vehicleData.model ? this.vehicleData.model : '',
        year: this.vehicleData.year ? this.vehicleData.year : '',
        vin: this.vehicleData.vin ? this.vehicleData.vin : '',
        doors: this.vehicleData.doors ? this.vehicleData.doors : '',
        registrationexpdate: this.vehicleData.registrationexpdateformatted
          ? this.vehicleData.registrationexpdateformatted
          : '',
        tag: this.vehicleData.tag ? this.vehicleData.tag : '',
        colorid: this.vehicleData.colorid ? this.vehicleData.colorid : '',
      });
    }

    if (changes['disabledInput'] && this.disabledInput) {
      this.onDisabledInputs();
    }
  }

  ngOnInit() {
    this.onLoadMakes();
    this.onLoadYears();
    this.onLoadVehicleColor();
    this.vinLookupSubscriptions.push(
      this.serviceVehicle.vinLookupEnabled$.subscribe({
        next: (isEnabled: boolean) => {
          this.vinLookupEnabled = isEnabled;
        },
      }),
      this.serviceVehicle.vinLookupLoading$.subscribe({
        next: (isLoading: boolean) => {
          this.vinLookupLoading = isLoading;
        },
      }),
    );
  }

  get vinLookupIconClass(): string {
    return this.vinLookupLoading ? 'fa-spinner fa-spin' : 'fa-search';
  }

  onVinLookup(): void {
    if (!this.vinLookupEnabled || this.vinLookupLoading) {
      return;
    }
    this.serviceVehicle.requestVinLookup();
  }

  onVinLookupKeydown(event: KeyboardEvent): void {
    if (!this.vinLookupEnabled) {
      return;
    }
    event.preventDefault();
    this.onVinLookup();
  }

  onCreateForm() {
    this.formValidateVin = this.fb.group({
      vin: ['', [Validators.required, Validators.minLength(constant.VIN_LENGTH), Validators.maxLength(constant.VIN_LENGTH)]],
      doors: ['', Validators.required],
      make: [''],
      model: [''],
      year: ['', Validators.required],
      tag: ['', Validators.required],
      registrationexpdate: [''],
      colorid: ['', Validators.required],
    });

    this.formValidateVin.get('vin').statusChanges.subscribe(status => {
      const isValid = status === 'VALID';
      this.serviceVehicle.setVinValidity(isValid);
    });
  }

  onManualMark() {
    this.manual = !this.manual;
  }

  onLoadMakes() {
    this.validateVINService.getOnyMakes(true).subscribe(
      (resp: any) => {
        if (resp) {
          this.makeArray = resp;
          this.onLoadModel();
        }
      },
      (error) => {
        this.sweetAlertHelper.createCustomAlert({
          title: 'Error!',
          text: error.message,
          type: 'error',
        });
      }
    );
  }

  onLoadModel() {
    const make = this.formValidateVin.get('make').value;
    if (make) {
      this.validateVINService.getModels2(make).subscribe(
        (resp: any) => {
          if (resp) {
            this.modelArray = resp;
          }
        },
        (error) => {
          this.sweetAlertHelper.createCustomAlert({
            title: 'Error!',
            text: error.message,
            type: 'error',
          });
        }
      );
    }
  }

  onLoadYears() {
    const nexYear = new Date().getFullYear() + 1;
    const end = nexYear - 40;
    for (let i = nexYear; i >= end; i--) {
      this.yearsArray.push({ year: i });
    }
  }

  onLoadVehicleColor() {
    this.serviceVehicle.getVehicleColor().subscribe(
      (resp: any) => {
        this.colorArray = resp;
      },
      (error) => {
        this.sweetAlertHelper.createCustomAlert({
          title: 'Error!',
          text: error.message,
          type: 'error',
        });
      }
    );
  }

  onOpenSearchModal(type: 'Model' |'Make') {
    this.titleModal = type;
    this.searchModal.open();
  }

  onChangeMakeItem(event: any) {
    if (event) {
      this.formValidateVin.patchValue({
        make: event,
        model: '',
        year: '',
      });
      this.onLoadModel();
      this.searchModal.close();
    }
  }

  onChangeModelItem(event: any) {
    if (event) {
      this.formValidateVin.patchValue({ model: event });
      this.searchModal.close();
    }
  }

  onSubscribeForm() {
    this.formValidateVin.valueChanges.subscribe((val) => {
      this.formValues.emit(val);
    });
  }

  onDateChange(event: any) {
    this.formValidateVin.patchValue({registrationexpdate: event.formatted});
  }

  onCancel() {
    this.searchModal.close();
  }

  onDisabledInputs() {
    this.formValidateVin.get('vin').disable();
    this.formValidateVin.get('doors').disable();
    this.formValidateVin.get('make').disable();
    this.formValidateVin.get('model').disable();
    this.formValidateVin.get('year').disable();
    this.formValidateVin.get('tag').disable();
    this.formValidateVin.get('registrationexpdate').disable();
    this.formValidateVin.get('colorid').disable();
  }

  ngOnDestroy(): void {
    if (this.vinLookupSubscriptions && this.vinLookupSubscriptions.length) {
      this.vinLookupSubscriptions.forEach((sub: Subscription) => sub.unsubscribe());
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/validate-vin/validate-vin.component.ts